// check backend type for statuses explanation
export enum PayoutOrderStatus {
  New = 'new',
  Requisites = 'requisites',
  Dispute = 'dispute',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Error = 'error',
  /**
   * @deprecated Unused after SPAY-2240
   */
  TraderAccept = 'trader_accept',
  TraderPayment = 'trader_payment',
}
